module.exports = __webpack_public_path__ + "static/media/Initab.266389f0.png";